import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class CpnyIdInterceptor implements HttpInterceptor {

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Obtener el CpnyID del localStorage
    const selectedCpnyID = localStorage.getItem('selectedCpnyID');
    
    if (selectedCpnyID) {
      // Clonar la request y agregar el header CpnyID
      const modifiedReq = req.clone({
        headers: req.headers.set('CpnyID', selectedCpnyID)
      });
      
      return next.handle(modifiedReq);
    }
    
    // Si no hay CpnyID, continuar con la request original
    return next.handle(req);
  }
}
